import { GroupedHistogram } from '@repo/videa-components/src/common-charts/index';
import { chartColors } from 'node_modules/@repo/videa-components/src/common-charts/themes/colors';

export const BenchmarkViz = ({
  opportunityRate,
  lowerBenchmark,
  upperBenchmark,
  isClinical,
  providerRatesDistribution,
}: {
  opportunityRate?: number;
  lowerBenchmark?: number;
  upperBenchmark?: number;
  providerRatesDistribution?: Record<number, number>;
  isClinical?: boolean;
}) => {
  if (
    lowerBenchmark === undefined ||
    upperBenchmark === undefined ||
    opportunityRate === undefined
  ) {
    return null;
  }

  return (
    <div className="vai-flex vai-relative vai-w-full vai-items-center vai-justify-center">
      <GroupedHistogram
        data={[
          {
            name: 'Provider Rates Distribution',
            data: Object.values(providerRatesDistribution || {}),
          },
        ]}
        chartOptions={{
          height: 120,
          colors: [chartColors['chart-tint']?.['viz-empty'] ?? '#000000'],
          lineWidth: 0,
          yAxisMax:
            Math.max(
              ...Object.values(providerRatesDistribution || {}).filter(
                (value) => !isNaN(value),
              ),
            ) + 1,
          tooltipFormatter: function (this: any) {
            return `${this.x * 10}-${this.x * 10 + 10}% Completion Rate: ${this.y} providers`;
          },
          xAxisFormatter: function (this: any) {
            return `${this.value * 10}%`;
          },
          plotLines: [
            {
              value: opportunityRate,
              dashStyle: 'Dash',
            },
          ],
        }}
        buckets={[
          {
            label: lowerBenchmark > 0.2 ? 'Low' : '',
            color: isClinical ? 'vai-bg-chart-tint-1' : 'vai-bg-chart-tint-2',
            textColor: isClinical
              ? 'vai-text-chart-shade-1'
              : 'vai-text-chart-shade-2',
            width: lowerBenchmark,
          },
          {
            label: upperBenchmark - lowerBenchmark > 0.4 ? 'Medium' : '',
            color: isClinical
              ? 'vai-bg-chart-normal-1'
              : 'vai-bg-chart-normal-2',
            textColor: 'vai-text-white',
            width: upperBenchmark - lowerBenchmark,
          },
          {
            label: 1 - upperBenchmark > 0.2 ? 'High' : '',
            color: isClinical ? 'vai-bg-chart-shade-1' : 'vai-bg-chart-shade-2',
            textColor: 'vai-text-white',
            width: 1 - upperBenchmark,
          },
        ]}
        size="small"
      />
    </div>
  );
};
